export enum HelixSearchV2SortBy {
    booleanSearchScore = 'booleanSearchScore',
    relationshipScore = 'relationshipScore',
    combined = 'combined',
    llmRelevanceScore = 'llmRelevanceScore',
}

export enum HelixSearchV2SortDirection {
    asc = 'asc',
    desc = 'desc',
}

export enum HelixSearchV2ShortlistFilterValues {
    yes = 'yes',
    no = 'no',
    none = 'none',
}

export type HelixSearchV2RoleContextFilters = {
    shortlistedValues?: HelixSearchV2ShortlistFilterValues[]
}

export type HelixSearchV2FilterOptions = {
    mustBeInBooleanSearchResults?: boolean
    mustHaveRelationship?: boolean
    networkSeedPersonIds?: string[]
    minRelationshipScore?: number
    roleContextFilters?: HelixSearchV2RoleContextFilters
    mustBeTopPick?: boolean
}

export type HelixSearchV2SortOptions = {
    sortBy: HelixSearchV2SortBy
    direction?: HelixSearchV2SortDirection
}

export type GetHelixSearchResultsV2Req = {
    sst: string
    logId: string
    pageNumber?: number
    perPage?: number
    filterOptions?: HelixSearchV2FilterOptions
    sortOptions?: HelixSearchV2SortOptions
}

export type HelixSearchV2ResultDto = {
    personId: string
    rank: number
    booleanSearchScore?: number
    booleanSearchScoreNormalised?: number
    aggregatedRelationshipScore?: number
    combinedScore?: number
    llmRelevanceScoreScore?: number
    llmRelevanceScoreReason?: string
    llmRelevanceScoreTopPick?: boolean
}

export type GetHelixSearchResultsV2Res = {
    totalCount: number
    pageNumber: number
    perPage: number
    results: HelixSearchV2ResultDto[]
}

export type GetHelixSearchResultsCountV2Req = {
    sst: string
    logId: string
    filterOptions?: HelixSearchV2FilterOptions
    sortOptions?: HelixSearchV2SortOptions
}

export type GetHelixSearchResultsCountV2Res = {
    totalCount: number
}
